// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2kdyH","footer":"ModalUpdate_footer__3gn75"};